import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import * as clientOptionsActions from './client-options.actions';
import { map, catchError, switchMap, withLatestFrom } from 'rxjs/operators';
import { of, EMPTY } from 'rxjs';
import { ClientOptionsService, ClientOptionsSelectors } from '../../../store';

@Injectable()
export class ClientOptionsEffects {

     LoadClientOptions$ = createEffect(() => this.actions$.pipe(
        ofType(clientOptionsActions.LOAD_CLIENT_OPTIONS),
        withLatestFrom(this.clientOptionsSelector.clientOptionsLoaded$),
        switchMap(([, isLoaded]) => {
            if (isLoaded) {
                return EMPTY;
            } else {
                return this.clientOptionsService.getCreaditOptions().pipe(
                    map(options => {
                        options.companyTypes = options.companyTypes.sort((a, b) => this.arrSort(a, b));
                        options.municipalities = options.municipalities.sort((a, b) => this.propSort(a, b, 'kommunenavn'));
                        options.relationTypes = options.relationTypes.sort((a, b) => this.propSort(a, b, 'tekst'));
                        options.clientServices = options.clientServices.sort((a, b) => a.orden - b.orden);
                        return options;
                    }),
                    map(sortedOptions => new clientOptionsActions.LoadClientOptionsSuccess(sortedOptions)),
                    catchError(() => of(new clientOptionsActions.LoadClientOptionsFailed())
                ));
            }
        })
    ));

    arrSort = function(a, b) {
        const aColumn = a.toLocaleUpperCase().trim();
        const bColumn = b.toLocaleUpperCase().trim();
        return aColumn.localeCompare(bColumn, undefined, { numeric: true });
    };

    propSort = function(a, b, prop: string) {
        const aColumn = a[prop].toLocaleUpperCase().trim();
        const bColumn = b[prop].toLocaleUpperCase().trim();
        return aColumn.localeCompare(bColumn, undefined, { numeric: true });
    };

    constructor(
        private actions$: Actions,
        private clientOptionsSelector: ClientOptionsSelectors,
        private clientOptionsService: ClientOptionsService,
    ) {}
}
